<template>
    <div class="uploader">
        <div class="image" v-show="previewSrc" :style="{ 'background-image': 'url(' + previewSrc + ')' }">
            <button type="button" v-show="previewSrc" class="button btn-danger" @click="removeFile">
                <i class="far fa-times-circle"></i>
            </button>
        </div>
        <input v-if="isRequired"  ref="uploader" style="opacity: 0 ; position: absolute; right: 0; left: 0; margin-left: 30%; margin-right: auto;" type="file" :id="name" :name="name" @change="inputChanged" required>
        <input v-else  ref="uploader" style="opacity: 0 ; position: absolute; right: 0; left: 0; margin-left: 30%; margin-right: auto;" type="file" :id="name" :name="name" @change="inputChanged">
        <button type="button" v-show="! previewSrc" class="button btn-primary" @click="selectFile">
            <i class="fas fa-camera-retro"></i>
            <p class="label">{{ label }}</p>
        </button>

    </div>
</template>

<script>
export default {
    name: 'uploader',
    props: ['name', 'file', 'label', 'isRequired'],
    data: () => ({
        addedFile: null,
        removed: false
    }),
    computed: {
        previewSrc() {
            if (! this.addedFile) {
                return this.removed ? false : this.file;
            }

            return URL.createObjectURL(this.addedFile);
        }
    },
    methods: {
        inputChanged(event) {
            this.$emit('input', event.target.files);
            this.addedFile = event.target.files[0];
            this.removed = false;
        },
        selectFile() {
            this.$refs.uploader.click();
        },
        removeFile() {
            this.$refs.uploader.value = '';
            this.addedFile = null;
            this.removed = true;
        }
    }
};
</script>
<style>
.uploader{
    text-align: center;
    position: relative;
}
.uploader .button.btn-primary {
    color: #660000;
    width: 100%;
    height: 150px;
    border-radius: 3px;
    min-width: 125px;
    padding: 0px;
    border: 1px solid #660000;
}
.uploader .button.btn-primary i{
    font-size: 5rem;
}

.uploader .button.btn-primary .label{
    color: #660000;
    font-weight: normal;
}
.uploader  img.img-responsive{
    color: #fff;
    width: 100%;
    height: 150px;
    border-radius: 50%;
    min-width: 125px;
    padding: 0px;
}
.uploader .image{
    position: relative;
    width: 100%;
    height: 150px;
    background-color: transparent;
    border-radius: 3px;
    min-width: 125px;
    padding: 0px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    margin: auto;

}
.uploader .button.btn-danger{
    background-color: rgba(16, 16, 16, 0.34);
    position: absolute;
    top: 0px;
    right: 0;
    color: #660000;
    width: 100%;
    height: 150px;
    border-radius: .5rem;
    border-color: rgb(154, 43, 133);
    font-size: 30px;
    border: 1px solid #660000;
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/front/components/Uploader.vue